module.exports = __webpack_public_path__ + "img/logo.e129520.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logo.svg
// module id = ./assets/images/logo.svg
// module chunks = 15